/**
* Blinds / config ATC gate (theme-owned).
* Keeps Add to cart disabled until Smart Product Customizer options are in the DOM.
* Survives app script failure, API failure, and the app unlocking ATC on load error.
*/
(function () {
  'use strict';

  var OPTIONS_FORM_SELECTOR = '.custom-fields-form__form';
  var READY_ATTR = 'data-custom-fields-ready';
  var APP_LOCK_ATTR = 'data-custom-fields-atc-locked';
  var syncScheduled = false;

  function requiresConfig() {
    return Boolean(document.querySelector('[data-cf-requires-config="1"]'));
  }

  function optionsAreLoaded() {
    var form = document.querySelector(OPTIONS_FORM_SELECTOR);
    if (!form) return false;

    var wrapper = form.closest('.custom-fields-form');
    if (wrapper && wrapper.classList.contains('custom-fields-form--hidden')) return false;

    return Boolean(
      form.querySelector(
        '.custom-field, [data-option-id], .custom-field__pricing-lookup, .custom-fields-form__fields .custom-field'
      )
    );
  }

  function setReady(ok) {
    document.documentElement.setAttribute(READY_ATTR, ok ? '1' : '0');
  }

  function getConfigSubmitButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        'button.product-form__submit[data-cf-requires-config="1"], button[name="add"][data-cf-requires-config="1"]'
      )
    );
  }

  /**
   * The app marks the /cart/add form while an add-to-cart (or template load) is in flight.
   * While marked, do not re-enable the button, otherwise Dawn's aria-disabled guard
   * is wiped immediately and a second click starts another add.
   */
  function isAppLocked(button) {
    var form = button.closest('form');
    return Boolean(form && form.getAttribute(APP_LOCK_ATTR) === '1');
  }

  function syncAtcState() {
    if (!requiresConfig()) return;

    var ready = optionsAreLoaded();
    setReady(ready);

    getConfigSubmitButtons().forEach(function (button) {
      if (button.dataset.priceLimitDisabled === 'true') {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        return;
      }

      if (ready) {
        if (isAppLocked(button)) return;
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      } else {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(function () {
      syncScheduled = false;
      syncAtcState();
    });
  }

  function init() {
    if (!requiresConfig()) return;

    setReady(false);
    syncAtcState();

    var observer = new MutationObserver(scheduleSync);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'hidden', 'aria-disabled', APP_LOCK_ATTR],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();